








































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { IIndicator } from '@/model/meta';
import { v4 as uuidv4 } from 'uuid';

import { required, maxLength } from 'vuelidate/lib/validators';

import BaseTable from '@/components/Table/BaseTable.vue';
import BaseModalForm from '@/components/Form/BaseModalForm.vue';

export default Vue.extend({
    name: 'Indicators',
    metaInfo: {
        title: 'Показатели',
    },
    components: {
        BaseTable,
        BaseModalForm,
    },
    methods: {
        ...mapActions('administration', {
            loadData: 'loadIndicatorsGrid',
            createItem: 'createIndicator',
            deleteItem: 'deleteIndicator',
            updateItem: 'updateIndicator',
            resetForm: 'resetForm'
        }),
        editModalShow(selectObj: IIndicator): void {
            this.editMode = 'edit';
            this.formShow = true;
            this.selected = selectObj;
        },
        newModalShow(): void {
            this.editMode = 'new';
            this.formShow = true;
        },
        deleteModalShow(selectObj: IIndicator): void {
            this.selected = selectObj;
            this.deleteShow = true;
        },
        submitForm(editObj: IIndicator): void {
            if (this.editMode === 'new') {
                this.createItem(editObj).then((result: boolean) => {
                    if (result === true) this.closeModalForm();
                });
            } else {
                this.updateItem(editObj).then((result: boolean) => {
                    if (result === true) this.closeModalForm();
                });
            }
        },
        submitDeleteForm(editObj: IIndicator): void {
            this.deleteItem(editObj).then((result: boolean) => {
                if (result === true) this.closeModalForm();
            });
        },
        closeModalForm(): void {
            this.resetForm();
            this.formShow = false;
            this.deleteShow = false;
        },
    },
    computed: {
        ...mapGetters('administration', {
            allData: 'getIndicatorsGrid',
            preloader: 'getPreloader',
            failLoading: 'getFailLoading',
            activeFormRequest: 'getActiveFormRequest',
            failedFormRequest: 'getFailedFormRequest',
        }),
        selectedName(): string {
            return this.selected === undefined ? '' : this.selected.name;
        },
        deleteMessage(): string {
            return 'Удалить выбранный показатель(' + this.selectedName + ')?';
        },
    },
    mounted() {
        this.loadData();
    },
    data() {
        return {
            fields: [
                { key: 'code', label: 'Код', sortable: true },
                { key: 'name', label: 'Наименование', sortable: true },
                { key: 'description', label: 'Описание', sortable: true },
                { key: 'isActive', label: 'Активность', sortable: true },
            ],
            selected: undefined as undefined | IIndicator,
            formShow: false,
            deleteShow: false,
            editMode: 'new' as 'new' | 'edit',
            emptyObject: {
                indicatorId: uuidv4(),
                code: undefined as string | undefined,
                name: undefined as string | undefined,
                description: undefined as string | undefined,
                isActive: false as boolean,
            },
            formSettings: [
                {
                    name: 'code',
                    idPrefix: 'code-name',
                    labelText: 'Код',
                    inputType: 'input',
                    placeholder: 'Введите код показателя',
                    errorText:
                        'Ошибка. Обязательный параметр. Максимум 50 символов.',
                    validations: {
                        required,
                        maxLength: maxLength(50),
                    },
                },
                {
                    name: 'name',
                    idPrefix: 'name-name',
                    labelText: 'Наименование',
                    inputType: 'input',
                    placeholder: 'Введите наименование показателя',
                    errorText:
                        'Ошибка. Обязательный параметр. Максимум 50 символов.',
                    validations: {
                        required,
                        maxLength: maxLength(50),
                    },
                },
                {
                    name: 'description',
                    idPrefix: 'description-name',
                    labelText: 'Описание',
                    inputType: 'textarea',
                    textareaRows: 6,
                    placeholder: 'Введите описание показателя',
                    errorText: 'Ошибка. Максимальная длинна 500 символов.',
                    validations: {
                        maxLength: maxLength(500),
                    },
                },
                {
                    name: 'isActive',
                    idPrefix: 'is-active',
                    labelText: 'Активность',
                    inputType: 'checkbox',
                    checkedValue: true,
                    uncheckedValue: false,
                    validations: {
                        required,
                    },
                },
            ],
        };
    }
});
